import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoginResponseInterface } from "@core/interfaces/auth/login-response.interface";
import { TwoFactorStatusInterface } from "@core/interfaces/auth/two-factor-status.interface";
import {
  TwoFactorVerificationRequestInterface,
  TwoFactorVerificationResponseInterface
} from "@core/interfaces/auth/two-factor-verification.interface";
import { BaseService } from "@core/services/base.service";
import { LoadingService } from "@core/services/loading.service";
import { environment } from "@env/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class AuthV2ApiService extends BaseService {
  private readonly apiUrl = `${environment.classicApiUrl}/api/v2/auth`;

  constructor(
    public readonly loadingService: LoadingService,
    private readonly http: HttpClient
  ) {
    super(loadingService);
  }

  login(username: string, password: string): Observable<LoginResponseInterface> {
    return this.http.post<LoginResponseInterface>(
      `${this.apiUrl}/login/`,
      { username, password },
      { withCredentials: true }
    );
  }

  verify2FA(request: TwoFactorVerificationRequestInterface): Observable<TwoFactorVerificationResponseInterface> {
    return this.http.post<TwoFactorVerificationResponseInterface>(`${this.apiUrl}/verify-2fa/`, request, {
      withCredentials: true
    });
  }

  get2FAStatus(): Observable<TwoFactorStatusInterface> {
    return this.http.get<TwoFactorStatusInterface>(`${this.apiUrl}/2fa-status/`, { withCredentials: true });
  }

  resend2FACode(sessionToken: string): Observable<{ success: boolean; message?: string }> {
    return this.http.post<{ success: boolean; message?: string }>(
      `${this.apiUrl}/resend-2fa-code/`,
      { session_token: sessionToken },
      { withCredentials: true }
    );
  }

  logout(): Observable<{ success: boolean; message: string; token_deleted: boolean }> {
    return this.http.post<{ success: boolean; message: string; token_deleted: boolean }>(
      `${this.apiUrl}/logout/`,
      {},
      { withCredentials: true }
    );
  }
}
